import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  GetMasterCity,
  CreateReferralData,
} from "../../services/EmployeeReferralService";
import { GetVacancyTypeList } from "../../services/VacancyTypeServices";
import { GetDepartmentList } from "../../services/DepartmentService";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";
import api from "../../api";

function EmployeeReferralCreate() {
  const { t } = useTranslation();
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState([
    { label: t(`EmployeeReferral.Active`), value: "1", id: "1" },
    { label: t(`EmployeeReferral.In Active`), value: "0", id: "0" },
  ]);
  const [masterCity, setMasterCity] = useState([]);
  const [vacancyType, setVacancyType] = useState([]);
  const [departmentType, setDepartmentType] = useState({});
  const [Job, setJob] = useState([]);

  useEffect(() => {
    GetDepartmentList()
      .then(res => {
        if (res?.status === 200) {
          let responseData = res?.data;
          responseData = decryptDataFromArray(responseData);

          let departments = responseData?.data?.map(item => ({
            label: item?.name,
            value: item?.id,
            id: item?.id,
          }));
          setDepartmentType(departments);
        }
      })
      .catch(err => {
        console.error("Error fetching department list:", err);
        setErrors("No data available");
      });
  }, []);

  useEffect(() => {
    GetVacancyTypeList()
      .then(res => {
        let responseData = decryptDataFromArray(res?.data);
        if (responseData?.status) {
          let vacrr = responseData?.data?.map(item => ({
            label: item?.title,
            value: item?.id,
            id: item?.id,
          }));
          setVacancyType(vacrr);
        } else {
          setErrors("No data available");
        }
      })
      .catch(err => {
        setErrors("No data Available");
      });
    //getFilterInfo()
  }, []);

  const GetReferralDataCities = () => {
    GetMasterCity()
      .then(res => {
        //console.log('24:GetReferralDataSingleRow',res)
        if (res.data.status === "success") {
          //console.log('GetEmployeeReferralList:::27',res.data.cities)
          let master_cities = res.data.cities?.map(item => ({
            label: item?.city,
            value: item?.id,
            id: item?.id,
          }));

          setMasterCity(master_cities);
        }
      })
      .catch(err => {
        setErrors("No data Available");
      });
  };
  useEffect(() => {
    GetReferralDataCities();
  }, []);

  const handleChangeVacancyTypeValuePopulate = e => {
    const lang_id =
      localStorage.getItem("lang_id") !== "1"
        ? localStorage.getItem("lang_id")
        : "1";
    let vacancy_type_id = e?.value;
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/job/fetch-jobbyvacancy/${vacancy_type_id}`,
      )
      .then(response => {
        const alljobs = response.data.jobdata;
        let data = alljobs?.map(item => ({
          id: item?.id,
          label: item?.title,
          value: item?.id,
        }));
        setJob(data);
      })
      .catch(err => console.log("Error:::", err));
    setFormDataValues(prevState => ({
      ...prevState,
      vacancy_type_id: e?.value,
    }));
  };

  const handleChangeVacancyValuePopulate = e => {
    const job_id = e?.value;
    console.log(job_id, "job_id");
    setFormDataValues(prevState => ({
      ...prevState,
      vacancy_id: job_id,
    }));
  };
  const handleChangeDepartmentValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      dept_id: e?.value,
    }));
  };

  /* State Field selected value */
  const handleStatusOptionSelection = id => {
    let record = status?.filter(item => item?.id == id);
    // console.log("Record:::", record);
    return record;
  };
  const handleChangeStatusValuePopulate = e => {
    //console.log('handleStatusValuePopulate:::',e)
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };
  /* City Field selected value */
  const handleCityOptionSelection = id => {
    //console.log("Record:::", id);
    let record = masterCity?.filter(item => item?.id == id);
    //console.log("handleCityOptionSelection:::", record);
    return record;
  };
  const handleChangeCityValuePopulate = e => {
    //console.log('handleStatusValuePopulate:::',e)
    setFormDataValues(prevState => ({
      ...prevState,
      city_id: e?.id,
    }));
  };
  /* Preferred Location Field selected value */
  const handlePreferredLocOptionSelection = id => {
    //console.log("Record:::", id);
    let record = masterCity?.filter(item => item?.id == id);
    //console.log("handleCityOptionSelection:::", record);
    return record;
  };
  const handleChangePreferredLocValuePopulate = e => {
    //console.log('handleStatusValuePopulate:::',e)
    setFormDataValues(prevState => ({
      ...prevState,
      preferred_location: e?.id,
    }));
  };

  /* Handle Change Event */
  const handleChange = e => {
    setFormDataValues({ ...formDataValues, [e.target.name]: e.target.value });
    console.log("setFormData:::", e.target.value);
  };

  /* Handle Submit*/
  const handleSubmit = async content => {
    const obj = {
      id: content?.id,
      vacancy_type_id: content?.vacancy_type_id,
      dept_id: content?.dept_id,
      emp_id: content?.emp_id,
      ref_emp_name: content?.ref_emp_name,
      ref_emp_email: content?.ref_emp_email,
      ref_emp_mobile: content?.ref_emp_mobile,
      candidate_name: content?.candidate_name,
      candidate_email: content?.candidate_email,
      candidate_mobile: content?.candidate_mobile,
      city_id: content?.city_id,
      preferred_location: content?.preferred_location,
      status: content?.status,
      job_id: content?.vacancy_id,
    };
    // return false;
    CreateReferralData(obj)
      .then(res => {
        if (res.status === 200) {
          let messages = toast.success(
            t(`EmployeeReferral.Data Created Successfully`)
          );
          window.location.href = "/employee-referral-list";
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

 

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  
   if (!checkPermissionStatus("employee-referral-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`EmployeeReferral.Access Denied`)}</h4>
      </div>
    );
  }

  // Component Call

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center py-2 pt-0">
            <Col lg="6" md="6">
              <Link to="/employee-referral-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`EmployeeReferral.Create Employee Referral`)}
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
            <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
              <Link to="/employee-referral-list" className="btn btn-primary">
                Back To Listing
              </Link>
            </div>
          </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section employe-refre mt-2">
            <Container fluid>
              <Col lg="12">
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => {
                    handleSubmit(formDataValues);
                  }}
                >
                  <div data-repeater-list="outer-group" className="outer">
                    <div data-repeater-item className="outer">
                      {successMessage && (
                        <div class="alert alert-success" role="alert">
                          {successMessage}
                        </div>
                      )}
                      {errors && (
                        <div class="alert alert-danger" role="alert">
                          {errors}
                        </div>
                      )}
                      <Row>
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="vacancy_type_id"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Vacancy Type`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              title={
                                formDataValues.vacancy_type_id
                                  ? `${
                                      vacancyType.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.vacancy_type_id
                                      )?.label
                                    }`
                                  : `${t("EmployeeReferral.Vacancy Type")}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder={t(`EmployeeReferral.Select Type`)}
                                id="vacancy_type_id"
                                name="vacancy_type_id"
                                validate={{ required: { value: true } }}
                                options={vacancyType}
                                onChange={e =>
                                  handleChangeVacancyTypeValuePopulate(e)
                                }
                                aria-label={t(`EmployeeReferral.Vacancy Type`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">
                              {errors.vacancy_type_id}
                            </div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="department"
                              className="col-form-label"
                            >
                              Job title
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              title={
                                formDataValues.vancany_id
                                  ? `${
                                      Job.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.vancany_id
                                      )?.label
                                    }`
                                  : `Job title`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder="Select Job title"
                                id="vancany_id"
                                name="vancany_id"
                                options={Job}
                                validationMessage={{
                                  value: "Please select a jobtitle",
                                }}
                                onChange={e =>
                                  handleChangeVacancyValuePopulate(e)
                                }
                                aria-label={t(`Job title`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">{errors.vancany_id}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="department"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Department`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <div
                              title={
                                formDataValues.dept_id
                                  ? `${
                                      departmentType.find(
                                        elem =>
                                          elem.value == formDataValues.dept_id
                                      )?.label
                                    }`
                                  : `${t(`EmployeeReferral.Department`)}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder={t(
                                  `EmployeeReferral.Select Department`
                                )}
                                id="dept_id"
                                name="dept_id"
                                options={departmentType}
                                validationMessage={{
                                  value: "Please select a department",
                                }}
                                onChange={e =>
                                  handleChangeDepartmentValuePopulate(e)
                                }
                                aria-label={t(`EmployeeReferral.Department`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">{errors.dept_id}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="emp_id" className="col-form-label">
                              {t(`EmployeeReferral.Emp ID`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <AvField
                              type="text"
                              className="form-control"
                              id="emp_id"
                              name="emp_id"
                              placeholder={t(`EmployeeReferral.Employee ID`)}
                              errorMessage={t(
                                `EmployeeReferral.Employee ID Required`
                              )}
                              onChange={handleChange}
                              title={`${t(
                                `EmployeeReferral.Emp ID`
                              ).toLowerCase()}`}
                            />

                            <div className="error">{errors.candidate_name}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ref_emp_name"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Emp Referral Name`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="ref_emp_name"
                              name="ref_emp_name"
                              placeholder={t(`EmployeeReferral.Employee Name`)}
                              errorMessage="Employee Name Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    `EmployeeReferral.Name is required`
                                  ),
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage: t(
                                    `EmployeeReferral.Name must be at least 2 characters`
                                  ),
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage: t(
                                    `EmployeeReferral.Name cannot exceed 50 characters`
                                  ),
                                },
                                pattern: {
                                  value: /^[A-Za-z\s]+$/,
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter a valid name with only alphabetic characters and spaces`
                                  ),
                                },
                              }}
                              value={formDataValues?.ref_emp_name || ""}
                              onChange={handleChange}
                              title={`${t(
                                `EmployeeReferral.Emp Referral Name`
                              ).toLowerCase()}`}
                            />
                            {/* <div className="error">{errors.candidate_name}</div> */}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ref_emp_email"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Referral Employee Email`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="ref_emp_email"
                              name="ref_emp_email"
                              placeholder={t(
                                `EmployeeReferral.Referral Employee Email`
                              )}
                              errorMessage="Referral Employee Email Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter your email`
                                  ),
                                },
                                email: {
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter a valid email address`
                                  ),
                                },
                              }}
                              value={formDataValues?.ref_emp_email || ""}
                              onChange={handleChange}
                              title={`${t(
                                `EmployeeReferral.Referral Employee Email`
                              ).toLowerCase()}`}
                            />
                            <div className="error">{errors.ref_emp_email}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ref_emp_mobile"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Referral Employee Mobile`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="integer"
                              className="form-control"
                              id="ref_emp_mobile"
                              name="ref_emp_mobile"
                              placeholder={t(
                                `EmployeeReferral.Referral Employee Mobile`
                              )}
                              errorMessage="Referral Employee Mobile Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter your mobile number`
                                  ),
                                },
                                pattern: {
                                  value: /^[0-9]{10}$/, // Regular expression for a 10-digit number
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter a valid 10-digit mobile number`
                                  ),
                                },
                              }}
                              value={formDataValues?.ref_emp_mobile || ""}
                              onChange={handleChange}
                              title={`${t(
                                `EmployeeReferral.Referral Employee Mobile`
                              ).toLowerCase()}`}
                            />
                            {/* <div className="error">{errors.ref_emp_mobile}</div> */}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="candidate_name"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Candidate Name`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="candidate_name"
                              name="candidate_name"
                              placeholder={t(`EmployeeReferral.Candidate Name`)}
                              errorMessage="Candidate Name Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    `EmployeeReferral.Name is required`
                                  ),
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage: t(
                                    `EmployeeReferral.Name must be at least 2 characters`
                                  ),
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage: t(
                                    `EmployeeReferral.Name cannot exceed 50 characters`
                                  ),
                                },
                                // Add more validation rules as needed
                                pattern: {
                                  value: /^[A-Za-z\s]+$/, // Regular expression for alphabetic characters and spaces
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter a valid name with only alphabetic characters and spaces`
                                  ),
                                },
                              }}
                              value={formDataValues?.candidate_name || ""}
                              onChange={handleChange}
                              title={`${t(
                                `EmployeeReferral.Candidate Name`
                              ).toLowerCase()}`}
                            />
                            {/* <div className="error">{errors.candidate_name}</div> */}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="candidate_email"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Candidate Email`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="integer"
                              className="form-control"
                              id="candidate_email"
                              name="candidate_email"
                              placeholder={t(
                                `EmployeeReferral.Candidate Email`
                              )}
                              title={`${t(
                                `EmployeeReferral.Candidate Email`
                              ).toLowerCase()}`}
                              errorMessage="Candidate Email Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter your email`
                                  ),
                                },
                                email: {
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter a valid email address`
                                  ),
                                },
                              }}
                              value={formDataValues?.candidate_email || ""}
                              onChange={handleChange}
                            />
                            {/* <div className="error">{errors.candidate_name}</div> */}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="candidate_mobile"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Candidate Mobile`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <AvField
                              type="integer"
                              className="form-control"
                              id="candidate_mobile"
                              name="candidate_mobile"
                              title={`${t(
                                `EmployeeReferral.Candidate Mobile`
                              ).toLowerCase()}`}
                              placeholder={t(
                                `EmployeeReferral.Candidate Mobile`
                              )}
                              errorMessage="Candidate Mobile Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter your mobile number`
                                  ),
                                },
                                pattern: {
                                  value: /^[0-9]{10}$/, // Regular expression for a 10-digit number
                                  errorMessage: t(
                                    `EmployeeReferral.Please enter a valid 10-digit mobile number`
                                  ),
                                },
                              }}
                              value={formDataValues?.candidate_mobile || ""}
                              onChange={handleChange}
                            />
                            {/* <div className="error">{errors.candidate_mobile}</div> */}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="city_id" className="col-form-label">
                              {t(`EmployeeReferral.City`)}:
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              title={
                                formDataValues.city_id
                                  ? `${
                                      masterCity.find(
                                        elem =>
                                          elem.value == formDataValues.city_id
                                      )?.label
                                    }`
                                  : `${t(`EmployeeReferral.City`)}`
                              }
                            >
                              <Select
                                id="city_id"
                                placeholder={t(`EmployeeReferral.Select City`)}
                                name="city_id"
                                className="mb-2"
                                options={masterCity}
                                value={handleCityOptionSelection(
                                  formDataValues?.city_id
                                )}
                                onChange={e => handleChangeCityValuePopulate(e)}
                                aria-label={t(`EmployeeReferral.City`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            {/* <div className="error">{errors.city_id}</div>  */}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="preferred_location"
                              className="col-form-label"
                            >
                              {t(`EmployeeReferral.Preferred Location`)}:
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              title={
                                formDataValues.preferred_location
                                  ? `${
                                      masterCity.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.preferred_location
                                      )?.label
                                    }`
                                  : `${t(
                                      `EmployeeReferral.Preferred Location`
                                    )}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder={t(
                                  `EmployeeReferral.Select Preferred Location`
                                )}
                                id="preferred_location"
                                name="preferred_location"
                                options={masterCity}
                                value={handlePreferredLocOptionSelection(
                                  formDataValues?.preferred_location
                                )}
                                onChange={e =>
                                  handleChangePreferredLocValuePopulate(e)
                                }
                                aria-label={t(
                                  `EmployeeReferral.Preferred Location`
                                )} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            {/* <div className="error">{errors.preferred_location}</div>  */}
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label className="col-form-label">
                              {" "}
                              {t(`EmployeeReferral.Status`)}:{" "}
                            </Label>

                            <div
                              title={
                                formDataValues.Status
                                  ? `${
                                      status.find(
                                        elem =>
                                          elem.value == formDataValues.Status
                                      )?.label
                                    }`
                                  : `${t(`EmployeeReferral.Status`)}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder={t(
                                  `EmployeeReferral.Select Status`
                                )}
                                id="status_id"
                                name="status"
                                options={status}
                                value={handleStatusOptionSelection(
                                  formDataValues?.status
                                )}
                                onChange={e =>
                                  handleChangeStatusValuePopulate(e)
                                }
                                aria-label={t(`EmployeeReferral.Status`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                          </FormGroup>
                        </Col>

                        <div data-repeater-list="outer-group" className="outer">
                          <Row className="justify-content-end ">
                            <Col lg={12}>
                              <div className="cta text-center d-flex gap-3 justify-content-left mt-4 mb-2">
                                <Button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={e => {
                                    console.log("sha");
                                    e.preventDefault();
                                    window.location.href =
                                      "/employee-referral-list";
                                  }}
                                >
                                  {" "}
                                  {t(`EmployeeReferral.Cancel`)}
                                </Button>
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  color="success"
                                >
                                  {t(`EmployeeReferral.Submit`)}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Row>
                    </div>
                  </div>
                </AvForm>
              </Col>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default EmployeeReferralCreate;
